import pic1 from "./Components/1.png";
import pic2 from "./Components/2.png";
import pic3 from "./Components/3.png";
import pic4 from "./Components/4.png";
import pic5 from "./Components/5.png";
import pic6 from "./Components/6.png";
import pic7 from "./Components/7.png";
import pic8 from "./Components/8.jpg";
import pic9 from "./Components/9.jpg";
import pic10 from "./Components/10.jpg";
import pic11 from "./Components/11.jpg";
import pic12 from "./Components/12.png";
import pic13 from "./Components/13.jpg";
import pic14 from "./Components/14.png";
import pic15 from "./Components/15.jpg";
import pic16 from "./Components/16.jpg";
import pic17 from "./Components/17.jpg";
import pic18 from "./Components/18.jpg";
import pic19 from "./Components/19.jpg";
import pic20 from "./Components/20.jpg";
import pic21 from "./Components/21.jpg";
import pic22 from "./Components/22.jpg";
import pic23 from "./Components/23.jpg";
import pic24 from "./Components/24.jpg";

// pictures that trail the mouse on every page
const trailImages = [pic1, pic2, pic3, pic4, pic5, pic6, pic7, pic8, pic9, pic10, pic11, pic12, pic13, pic14, pic15, pic16, pic17, pic18, pic19, pic20, pic21, pic22, pic23, pic24];

export default trailImages;
